import { render } from "./EditTranslationKeyModal.vue?vue&type=template&id=be8521d4"
import script from "./EditTranslationKeyModal.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./EditTranslationKeyModal.vue?vue&type=script&charset=utf-8&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__